module.exports = __webpack_public_path__ + "img/bg_stage.4c78545b.png";